import env from '@/utils/env'
import request from '@/request'
import localStorage from '@/utils/localStorage'
import handler from '@/utils/responseHandler'

export default {
  getWxPayToken(data = {}) {
    data.pid = 331216
    data.paySource = localStorage.get('ptid') || ''

    return Promise.resolve().then(() => {
      let result

      //微信环境
      if (env.isWeixin && !env.isWxwork) {
        let openid = localStorage.get('hbOpenid') || ''

        //需重新跳转去航班网页授权获取openid
        if (!openid) {
          result = Promise.reject(false)
        } else {
          data.openid = openid
          result = Promise.resolve(true)
        }
      }
      //其他环境
      else {
        result = Promise.resolve(true)
      }

      return result
    }).catch(() => {
      return Promise.reject({
        code: 'needReWxAuth',
        msg: '需微信授权才可继续支付'
      })
    }).then(() => {
      return request.oldPay({
        url: '/gateway/gtgj/qp',
        auth: 'yes',
        data,
        sidFields: ['uid', 'pid']
      }).then(handler.resBdData)
    })
  },
  getWxPayTokenV2(data = {}) {
    data.pid = 500330
    data.system = 'web-gaotie-vue'

    return Promise.resolve().then(() => {
      let result

      //微信环境
      if (env.isWeixin && !env.isWxwork) {
        let openid = data.openId || localStorage.get('hbOpenid') || ''

        //需重新跳转去航班网页授权获取openid
        if (!openid) {
          result = Promise.reject(false)
        } else {
          data.openId = openid
          result = Promise.resolve(true)
        }
      }
      //其他环境
      else {
        result = Promise.resolve(true)
      }

      return result
    }).catch(() => {
      return Promise.reject({
        code: 'needReWxAuth',
        msg: '需微信授权才可继续支付'
      })
    }).then(() => {
      return request.defray({
        url: '/api-pay/gateway.do',
        auth: 'yes',
        method: 'POST',
        data,
        sidFields: ['uid', 'pid', 'payOrderId', 'origin']
      }).then(handler.resBdData)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/wxPayToken.js